import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 5,
};

export const trainingDirectionListTableControllerSlice = createSlice({
    name: 'trainingDirectionListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const {changeCurrentPage} = trainingDirectionListTableControllerSlice.actions;

export default trainingDirectionListTableControllerSlice.reducer;